module.exports = {
      id: "illustrations:AU01-usage",
      viewBox: "0 0 272 238",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#illustrations:AU01-usage",
      toString: function () {
        return this.url;
      }
    }